import { render, staticRenderFns } from "./DeliveryNew_AddItemInvoice_List.vue?vue&type=template&id=3b5a4542&"
import script from "./DeliveryNew_AddItemInvoice_List.vue?vue&type=script&lang=js&"
export * from "./DeliveryNew_AddItemInvoice_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports